import { Box, Typography } from "@mui/material"
import { Examination, Project, Task, TaskStep } from "graphql/types"
import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"

import { DocumentCard } from "pages/ExaminationPage/DocumentCard"
import { allExaminations } from "utils/allExaminations"
import { getUniqueTaskTypes } from "utils/getUniqueTaskTypes"
import { ReportRightHeader } from "./ReportRightHeader"
import { ReportTaskDataCard } from "./ReportTaskData/ReportTaskDataCard"

type ReportRightBoxProps = {
  project: Project
}

export const ReportRightBox = (props: ReportRightBoxProps) => {
  const { project } = props
  const [searchParams] = useSearchParams()
  const examinationID = searchParams.get("examinationID")

  const examination = allExaminations(project).find(
    (examination) => examination.id === examinationID
  )
  const [filteredTask, setFilteredTask] = useState<TaskStep[]>([])
  const [tasks, setTasks] = useState<Task[]>([])

  useEffect(() => {
    if (examination) {
      const filteredTasks = examination.tasks
        .map((task) => {
          const isTestType = task.testDatas?.some(
            (data) => data?.type && filteredTask.includes(data.type)
          )
          if (isTestType) return task
          return null
        })
        .filter((task) => task !== null) as Examination["tasks"]

      setTasks(filteredTasks)
    }
  }, [examination, filteredTask, project])

  useEffect(() => {
    if (examination) {
      const uniqueTaskTypes = getUniqueTaskTypes(examination)
      setFilteredTask(uniqueTaskTypes)
    }
  }, [examination])

  const handleFilter = (filter: TaskStep[]) => {
    setFilteredTask(filter)
  }

  return (
    <Box sx={{ flex: 1, height: "calc(100vh - 100px)", padding: 1, overflow: "auto" }}>
      {examination && (
        <Box>
          <ReportRightHeader
            examination={examination}
            handleFilter={handleFilter}
            project={project}
          />

          {tasks.map((task) => (
            <Box key={task.id} sx={{ mb: 2 }}>
              <Typography variant="h6">{task.name}</Typography>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {task.testDatas.map((testData) => {
                  if (!testData || !filteredTask.includes(testData.type)) return null
                  return (
                    <Box key={testData.id}>
                      <ReportTaskDataCard
                        testData={testData}
                        deviceSetup={examination.deviceSetup}
                        examination={examination}
                      />
                    </Box>
                  )
                })}
              </Box>
            </Box>
          ))}

          <DocumentCard
            examination={examination}
            project={project}
            showDeviceImages={true}
            inTestReportUI={true}
          />
        </Box>
      )}
    </Box>
  )
}
